
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"83","height":"83","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M38.535 65.211V50.39a5.929 5.929 0 00-5.928-5.929H17.785a5.929 5.929 0 00-5.928 5.929v14.821a5.929 5.929 0 005.928 5.929h14.822a5.929 5.929 0 005.928-5.929zM17.785 50.39h14.822v14.821H17.785V50.39zm47.429-11.857H17.785a5.929 5.929 0 01-5.928-5.929V17.783a5.929 5.929 0 015.928-5.929h47.429a5.929 5.929 0 015.928 5.929v14.821a5.929 5.929 0 01-5.928 5.929zm0-5.929V17.783H17.785v14.821h47.429zm5.928 32.607V50.39a5.929 5.929 0 00-5.928-5.929H50.392a5.929 5.929 0 00-5.928 5.929v14.821a5.929 5.929 0 005.928 5.929h14.822a5.929 5.929 0 005.928-5.929zM50.392 50.39h14.822v14.821H50.392V50.39z","fill":"#888","fill-opacity":".2"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M76.083 6.917H6.917v69.166h69.166V6.917zM6.917 0A6.917 6.917 0 000 6.917v69.166A6.917 6.917 0 006.917 83h69.166A6.917 6.917 0 0083 76.083V6.917A6.917 6.917 0 0076.083 0H6.917z","fill":"#888","fill-opacity":".2"}})])
          )
        }
      }
    